export default __webpack_public_path__ + "images/assets/f8b840a4de27993449832fc92b27636f.svg";